import { motion } from "framer-motion";
import { fr } from "../content/fr";
import Img from "./Img";

// Aperçu "plateforme de gestion d'influenceurs IA" — remplace le noyau 3D dans le hero.
export default function PlatformPreview() {
  const p = fr.personas;
  return (
    <div className="platform" data-testid="platform-preview">
      <div className="platform__bar">
        <div className="platform__dots"><span /><span /><span /></div>
        <span className="platform__title mono">VIRALYA · {p.dashTitle}</span>
        <span className="platform__live"><i />{p.dashLive}</span>
      </div>

      <div className="platform__rows">
        {p.cards.map((c, i) => (
          <motion.div
            className="platform__row" key={c.nom}
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.25 + i * 0.12 }}
          >
            <Img className="platform__ava" src={c.img} srcSet={c.img.replace(/\.(jpe?g|png)$/i, "-168.webp")} sizes="84px" alt={c.nom} width={84} height={84} />
            <div className="platform__meta">
              <strong>{c.nom}</strong>
              <span className="platform__canal mono">{c.canal}</span>
            </div>
            <span className={`platform__chip chip-${i}`}><i />{c.etat}</span>
          </motion.div>
        ))}
      </div>

      <div className="platform__stats">
        {p.dashStats.map((s) => (
          <div className="platform__stat" key={s.l}>
            <div className="platform__stat-v">{s.v}</div>
            <div className="platform__stat-l mono">{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
